import React from "react";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";
import Planos from "../components/Planos";
import './Sobre.css';

const Servicos = () => {
  return (
    <>
      <Header2 />
      <Planos />
      <Footer />
    </>
  );
};

export default Servicos;
